import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSagesureLogoIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 33 38",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#80BC00",
		d: "M32.3 0H14.5C9.2 0 6 4.4 6 4.4L.3 11.6H18c5.3 0 8.5-4.4 8.5-4.4L32.3 0Zm0 26.2H14.5c-5.3 0-8.5 4.4-8.5 4.4L.3 37.8H18c5.3 0 8.5-4.4 8.5-4.4l5.7-7.2Zm0-1.5H14.5c-5.3 0-8.5-4.4-8.5-4.4L.3 13.1H18c5.3 0 8.5 4.4 8.5 4.4l5.7 7.2Z"
	})
});
export default SvgSagesureLogoIcon;
